import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Tooltip,
  IconButton,
  TextField,
} from "@mui/material";
import { rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterNetworks } from "./UseFooterNetworks";
import { useNavigate } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomPagination from "../../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../../components/DeleteRow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import useBreakpoints from "../../../../hooks/useBreakpoints";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function FooterNetworks(props) {
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooterNetworks, RemoveFooterNetworks, SetFooterNetworks } =
    UseFooterNetworks();
  const [networksRes, setNetworksRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const { isSmall } = useBreakpoints();
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );

  useEffect(() => {
    if (props.expanded === "panel3") {
      setProgress(true);
      GetFooterNetworks(homePageId?.id ? homePageId.id : 1, (Networks) => {
        setNetworksRes(Networks);
      });
    }
  }, [props.expanded, homePageId]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("panel3");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (props.expanded === "panel3") {
      const element = document.getElementById("panel3");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [props.expanded]);

  const newFunc = () => {
    return navigate("/footerManage/addNetwork", {
      state: {
        model: networksRes ? networksRes : [],
        expanded: props.expanded,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 100,
      align: "center",
      headerName: "اولویت",
      headerAlign: "center",
    },
    {
      field: "title",
      width: 250,
      align: "center",
      headerName: "عنوان",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "icon",
      width: 120,
      align: "center",
      headerName: "آیکن",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Avatar
            sx={{ bgcolor: "#d3d3d3", p: 0.5, borderRadius: 0 }}
            src={cellValues.row.icon}
          ></Avatar>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 160,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  navigate("/footerManage/editNetwork", {
                    state: {
                      model: cellValues.row,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                    name: cellValues.row.title,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  SetFooterNetworks(model, "", () => {
                    GetFooterNetworks(
                      homePageId?.id ? homePageId.id : 1,
                      (Certificates) => {
                        setNetworksRes(Certificates);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };

                if (
                  cellValues.row.rowIndex + 1 ==
                  networksRes?.items?.length + 1
                ) {
                  return;
                } else {
                  SetFooterNetworks(model, "", () => {
                    GetFooterNetworks(
                      homePageId?.id ? homePageId.id : 1,
                      (Certificates) => {
                        setNetworksRes(Certificates);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Accordion
      expanded={props.expanded === "panel3"}
      id="panel3"
      onChange={handleChange("panel3")}
      style={{ marginTop: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel3")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel3bh-content"
        id="panel3bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            اطلاعات شبکه های اجتماعی
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <TextField
            fullWidth
            sx={{ width: isSmall ? "90%" : "40%" }}
            value={networksRes?.title ? networksRes.title : ""}
            // error={errorState.title}
            label="عنوان"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setNetworksRes({ ...networksRes, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button
            onClick={() => {
              let model = {
                footerID: homePageId ? homePageId.id : 1,
                NetworkTitle: networksRes.title ? networksRes.title : "",
              };
              SetFooterNetworks(model, "", () => {
                GetFooterNetworks(
                  homePageId?.id ? homePageId.id : 1,
                  (Networks) => {
                    setNetworksRes(Networks);
                  }
                );
              });
            }}
            sx={{ width: "80px" }}
            color="secondary"
            variant="contained"
          >
            ثبت
          </Button>
        </Box>
        <Box sx={{ height: "30rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={100}
            rows={networksRes?.items ? networksRes.items : []}
            rowCount={
              networksRes?.items?.length ? networksRes?.items.length : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                newFunc: newFunc,
                isLtr: true,
                rowCount: networksRes?.items?.length
                  ? networksRes?.items.length
                  : "",
              },
            }}
          />
        </Box>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={""}
          callback={() => {
            setProgress(true);
            RemoveFooterNetworks(deleteState.id, () => {
              GetFooterNetworks(
                homePageId?.id ? homePageId.id : 1,
                (Networks) => {
                  setNetworksRes(Networks);
                }
              );
            });
          }}
        ></DeleteRow>
      </AccordionDetails>
    </Accordion>
  );
}
